<output class="ui-g-12 text-center"
	*ngIf="loading === true"
	aria-live="polite">
	<i class="loading-spinner theme-color fa fa-fw fa-spin fa-spinner"
		aria-hidden="true">
	</i>
	<span class="visually-hidden">
		Loading entity form
	</span>
</output>

<div class="ui-g-12 no-horizontal-padding text-left"
	*ngIf="loading === false"
	[ngClass]="{'no-content-animation': !showContentAnimation}"
	[@contentAnimation]="state">
	<app-dynamic-formly
		[formlyOptions]="formlyOptions"
		[dataSet]="entityInstance"
		[initialData]="databaseEntityInstance"
		[layoutSchema]="formlyEntityLayout"
		[context]="pageContext"
		(valuesChanged)="valuesChanged.emit($event)">
	</app-dynamic-formly>
</div>